import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .contactDropdown {
    max-width: none;
    width: 100%;
    margin-bottom: 10px;
    > div {
      > p {
        .placeholder {
          color: #898989;
        }
      }
    }
  }
`